import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepVehicle() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

        const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'auto'; // Definir el stepKey para este componente
    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Marca {isFieldRequired('auto.marca', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.marca" control={control} rules={getValidationRules('auto.marca', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.marca && <small className="p-error">{errors.auto.marca.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Modelo {isFieldRequired('auto.modelo', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.modelo" control={control} rules={getValidationRules('auto.modelo', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.modelo && <small className="p-error">{errors.auto.modelo.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Versión {isFieldRequired('auto.version', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.version" control={control} rules={getValidationRules('auto.version', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.version && <small className="p-error">{errors.auto.version.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Tipo de motor {isFieldRequired('auto.tipoMotor', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.tipoMotor" control={control} rules={getValidationRules('auto.tipoMotor', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.tipoMotor && <small className="p-error">{errors.auto.tipoMotor.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Tipo de auto {isFieldRequired('auto.tipoAuto', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.tipoAuto" control={control} rules={getValidationRules('auto.tipoAuto', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.tipoAuto && <small className="p-error">{errors.auto.tipoAuto.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Accesorios adicionales c/IVA {isFieldRequired('auto.accesoriosConIva', stepKey) && <span className="required-asterisk"> *</span>}    </label>
                    <Controller name="auto.accesoriosConIva" control={control} rules={getValidationRules('auto.accesoriosConIva', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.accesoriosConIva && <small className="p-error">{errors.auto.accesoriosConIva.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Estado de la placa {isFieldRequired('auto.estadoPlaca', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.estadoPlaca" control={control} rules={getValidationRules('auto.estadoPlaca', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.estadoPlaca && <small className="p-error">{errors.auto.estadoPlaca.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Agencia / Razón social {isFieldRequired('auto.agencia', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.agencia" control={control} rules={getValidationRules('auto.agencia', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.agencia && <small className="p-error">{errors.auto.agencia.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>No. serie {isFieldRequired('auto.numeroSerie', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.numeroSerie" control={control} rules={getValidationRules('auto.numeroSerie', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.numeroSerie && <small className="p-error">{errors.auto.numeroSerie.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Motor {isFieldRequired('auto.motor', stepKey) && <span className="required-asterisk"> *</span>}  </label>
                    <Controller name="auto.motor" control={control} rules={getValidationRules('auto.motor', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.motor && <small className="p-error">{errors.auto.motor.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Valor factura {isFieldRequired('auto.valorFactura', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.valorFactura" control={control} rules={getValidationRules('auto.valorFactura', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.valorFactura && <small className="p-error">{errors.auto.valorFactura.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Clave SAT producto/servicio {isFieldRequired('auto.satProductService', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.satProductService" control={control} rules={getValidationRules('auto.satProductService', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.satProductService && <small className="p-error">{errors.auto.satProductService.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Unidad SAT {isFieldRequired('auto.satUnit', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.satUnit" control={control} rules={getValidationRules('auto.satUnit', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.satUnit && <small className="p-error">{errors.auto.satUnit.message}</small>}
                </div>
               {/*  <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label>Numero de serie {isFieldRequired('auto.serialNumber', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="auto.serialNumber" control={control} rules={getValidationRules('auto.serialNumber', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.auto?.serialNumber && <small className="p-error">{errors.auto.serialNumber.message}</small>}
                </div> */}
            </div>
        </div>
    );
}


